"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _expandableHeaderModule = _interopRequireDefault(require("./expandable-header.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExpandableHeader = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
      title = _ref.title,
      editButtonComponent = _ref.editButtonComponent,
      isInitiallyExpanded = _ref.isInitiallyExpanded,
      children = _ref.children;

  var _useState = (0, _react.useState)(isInitiallyExpanded),
      _useState2 = _slicedToArray(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var handleClick = (0, _react.useCallback)(function () {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_expandableHeaderModule["default"].expandableHeader, _defineProperty({}, _expandableHeaderModule["default"].expanded, isExpanded), className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _expandableHeaderModule["default"].titleContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _expandableHeaderModule["default"].title
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _expandableHeaderModule["default"].titleText,
    onClick: handleClick,
    role: "presentation"
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: _expandableHeaderModule["default"].editComponent
  }, editButtonComponent))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _expandableHeaderModule["default"].content
  }, children));
});

ExpandableHeader.propTypes = {
  children: _propTypes["default"].node,
  editButtonComponent: _propTypes["default"].node,
  isInitiallyExpanded: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  title: _propTypes["default"].node
};
ExpandableHeader.defaultProps = {
  children: null,
  isInitiallyExpanded: false,
  editButtonComponent: null,
  title: '',
  className: ''
};
var _default = ExpandableHeader;
exports["default"] = _default;